import { useTranslation } from "react-i18next";

function navTranslationKey(href: string) {
  const value = href.toLowerCase();
  if (value === "/" || value === "/home") return "nav.home";
  if (value.includes("about")) return "nav.about";
  if (value.includes("store") || value.includes("channel")) return "nav.stores";
  if (value.includes("faq")) return "nav.faq";
  if (value.includes("blog") || value.includes("article")) return "nav.blog";
  if (value.includes("book") || value.includes("catalog")) return "nav.books";
  if (value.includes("contact")) return "nav.contact";
  if (value.includes("partner")) return "nav.partners";
  if (value.includes("service")) return "nav.services";
  if (value.includes("app")) return "nav.app";
  return "nav.more";
}

export default function LocalizedNavLabel({
  href,
  fallback,
}: {
  href: string;
  fallback: string;
}) {
  const { t } = useTranslation();
  return <>{t(navTranslationKey(href), { defaultValue: fallback })}</>;
}

